import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import buildAgenticPlans from 'pages/app/ai-agents-pricing/components/pricingData'
import customLanguageTexts from '../../../language'
import { getTimestampAsFullHumanDate, getPlanName } from '../../../helpers'
import './index.css'

const ModalSubscriptionDowngradeEndOfTerm = () => {
  const settings = useSelector(state => state.settings)
  const apps = useSelector(state => state.apps)
  const dispatch = useDispatch()

  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const { visibleModalID } = settings
  const modalID = 'subscriptionDowngradedEndOfTerm'
  const visible = modalID === visibleModalID

  // Resolve the downgrade target plan name.
  // For AI agent plans, getPlanName returns "Custom" since those IDs are not in the
  // chat plan registry. Look them up in the AI agents catalog first.
  const { planDowngradedTo } = apps.active
  const resolveDowngradedPlanName = () => {
    if (!planDowngradedTo) return null
    const agenticPlans = buildAgenticPlans(apps.aiAgentPlans)
    const normalizedId = planDowngradedTo.toLowerCase().replace(/overages-/gi, '')
    const matched = agenticPlans.find(
      p =>
        p.id && (normalizedId.includes(p.id.toLowerCase()) ||
          (p.annualId && normalizedId.includes(p.annualId.toLowerCase()))),
    )
    if (matched) return matched.name
    return getPlanName(planDowngradedTo, true)
  }
  const downgradedPlanName = resolveDowngradedPlanName()

  return (
    <Modal
      className="custom__downgradeEOT__modal"
      title={<div> {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_TITLE}</div>}
      open={visible}
      onCancel={handleCancel}
      footer={null}
    >
      <div className="">
        {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_DESCRIPTION}
        <b>{getTimestampAsFullHumanDate(apps.active.downgradesAt)}</b>{' '}
        {apps.active.planDowngradedTo !== undefined ? (
          <span>
            {' '}
            to <b>{downgradedPlanName}</b>
          </span>
        ) : (
          ''
        )}
        <br />
        {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_NOTE}{' '}
        <i className="fe fe-smile ml-2" />
      </div>
    </Modal>
  )
}

export default ModalSubscriptionDowngradeEndOfTerm
